var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('grid-two-column',[_c('template',{slot:"aside-left"},[_c('sidebar-left')],1),_c('template',{slot:"main"},[_c('home-content')],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }